<template  >
    <div class="home-region ancient">
        <div class="region-cont">
            <div class="tit tit-blue" >古籍知识库定制服务
                <div class="tit-bottom"></div>
            </div>
        </div>
        <div class="ancient-list">
            <ul class="ancient-list">
                <li class="list" v-for="(item,index) in ancientList" :key="index"  @mouseenter="mouChange(item)" @mouseleave="mouChange1(item)" @click="toPage(item)">
                    <div class="list-img">
                        <img width="100%" :src="item.img" alt="">
                    </div>
                    <div class="list-info" :class="item.mouseenter?'info-move':'info-out'">
                        <p class="list-title">{{item.title}}</p>
                        <div class="list-info-txt">{{item.info}}</div>
                        <div class="entrance" >进入</div> 
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import {saveFrontLog} from '@/io/api';
export default {
    data(){
        return { 
            ancientList:[
                {
                    title:'皮肤科',
                    info:'利用中医药词网技术、文献结构化加工技术，完成荨麻疹中医古籍知识的文献检索、文本化处理；利用本体技术、数据库技术完成知识库设计、知识库构建及知识库服务。集成关联分析、聚类分析、复杂网络分析等算法，建立可以对荨麻疹的病因病机、处方用药、临床表现等进行在线检索、挖掘分析、报告生成，可视化展示及上传数据个性化分析的皮肤病数据挖掘系统。',
                    img:require('../../../assets/images/home/pifu.jpg'),
                    href:'https://www.tcmkb.cn/platformMeasles/homePage',
                    mouseenter:false,
                },
                {
                    title:'食管癌',
                    info:'系统检索中医古籍、现代研究文献中有关食管癌及癌前病变的理论、经验方药及医案文献，对文献进行扫描、光学字符识别、PDF转换及结构化输出，搭建形成食管癌及癌前病变的古今文献数据库、方药数据库、医案数据库，实现食管癌及癌前病变的古今文献的检索与展示。',
                    img:require('../../../assets/images/home/shiguanai.png'),
                    href:'https://www.tcmkb.cn/platformEsophagealCancer/homePage',
                    mouseenter:false,
                },
                {
                    title:'慢性心衰',
                    info:'系统检索先秦至民国时期心衰古籍，包括《黄帝内经》《伤寒论》《金匮要略》《千金要方》《太平圣惠方》等经典古籍，并进行文本化及结构化处理，搭建形成慢性心衰的古籍文献数据库、诊疗知识库，实现慢性心衰的古籍文献及诊疗知识的检索与展示。',
                    img:require('../../../assets/images/home/xinshuai.jpg'),
                    href:'https://www.tcmkb.cn/platformHeartFailure/homePage',
                    mouseenter:false,
                }
            ]
        }
    },
    methods:{
        mouChange(item){
            item.mouseenter = true;
        },
        mouChange1(item){
            item.mouseenter = false;
        },
        toPage(item){
            saveFrontLog({ 
                moduleName: '古籍定制',
                operationType: '查看详情',
                logContent: `查看【${item.title}古籍知识库】。`,
            });
            this.$windowOpen({ url: item.href, isLogin: true });
        }
    }
}
</script>
<style lang="less" scoped>
.ancient{ 
    .region-cont{
        width: 1200px;
        margin: 0 auto;
        .tit{
            width: 330px;
        }
    }
    .ancient-list{
        display: flex;
        justify-content: space-between;
        width: 1200px;
        margin: 0 auto;
        .list{
            width: 380px;
            height: 240px;
            background: #fff;
            border-radius: 8px;  
            overflow: hidden;
            box-shadow: 0px 2px 16px 8px rgba(22,93,255,0.04);
            position: relative;
            .list-img,.list-info{
                position: absolute;
                left: 0;
                width: 100%; 
            }
            .list-img{
                top: 0;
                width: 100%;
                height: 100%;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .list-info{
                cursor: pointer;
                top: 200px;
                z-index: 100;
                left: 0;
                height: 40px;
                line-height: 24px;
                color: #000;
                // background: rgba(225,235,255,0.7);
                background: linear-gradient( 180deg,rgba(243,247,255,0.3) 0%, rgba(225,235,255,0.9) 100%);
                .list-title{
                    text-align: center;
                    height: 40px; 
                    font-size: 16px;
                    font-weight: bold;
                    padding-top: 10px;
                    color: #000;
                    
                }
                .list-info-txt{
                    padding:0px 20px;
                    height: 150px;
                }
                .entrance{
                     
                    text-align: right;
                    color: #0C55AA;
                    margin:10px 20px 0 0;
                    cursor: pointer;
                }
            } 
        }
    }
    .info-move {
        animation: myMou 0.5s;
        animation-fill-mode: forwards;
        
    }

    .info-out {
        animation: myMou1 0.5s;
        animation-fill-mode: forwards;
        height: 40px;
    }
    @keyframes myMou {
        0% {
            margin-top: 0px;
            height: 40px;
        }
        100% {
            margin-top: -200px;
            height: 240px;
        }
    }
    @keyframes myMou1 {
        0% {
            margin-top: -200px;
            height: 240px;
        }
        100% {
            margin-top: 0px;
            height: 40px;
        }
    } 
}
</style>